module.exports = __webpack_public_path__ + "media/images/client/favicons/site-tile-310x150-4680cf262e7cb9db69ebaee82009ff1d.png";